'use client'

import { useGraphql } from '@dustin-web/microsite-data/src/hooks/use-graphql'
import { ArticleCardList } from '@dustin-web/content-components/src/article-card-list'
import {
  GetArticleBoxListQuery,
  GetArticleBoxListQueryVariables,
} from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import { GetArticleBoxList } from '@contentsite/src/graphql/get-article-box-list.graphql'
import Icon from '@dustin-web/microsite-components/src/icon'

export type CardsArticleListBlockProps = {
  tagName?: string
  ID?: string
  category?: string
  hideCategory?: boolean
  hideTags?: boolean
  hideDate?: boolean
  numberOfBoxes?: number
  toBlogLink?: { text: string; url: string }
}

const stringValueToArray = (string?: string) => (string ? string.split(',').map(s => s.trim()) : [])

export const CardsArticleListBlock = ({
  tagName,
  ID,
  category,
  numberOfBoxes = 4,
  hideCategory,
  hideTags,
  hideDate,
  toBlogLink,
}: CardsArticleListBlockProps) => {
  const IDs = stringValueToArray(ID)
    .filter(s => /^\d+$/.test(s))
    .map(Number)
  const tagNames = stringValueToArray(tagName)
  const categories = stringValueToArray(category)
  const { data } = useGraphql<GetArticleBoxListQuery, GetArticleBoxListQueryVariables>(
    GetArticleBoxList,
    {
      variables: {
        numberOfBoxes: numberOfBoxes,
        mustIncludeAllTags: false,
        startIndex: 0,
        tagNames: tagNames,
        categoryNames: categories,
        articleIds: IDs,
      },
    }
  )

  const articles = data?.articleBoxList?.articles

  return (
    <>
      <ArticleCardList
        articlesList={articles}
        hideCategory={hideCategory}
        hideTags={hideTags}
        hideDate={hideDate}
      />
      {toBlogLink?.url && toBlogLink.text ? (
        <div className="d-flex justify-content-end u-mt-16">
          <a className="d-flex" href={toBlogLink.url} aria-label="to blog">
            <span className="u-mr-8">{toBlogLink.text}</span>
            <Icon name="arrow-right" className="i-16 u-ml-4" />
          </a>
        </div>
      ) : null}
    </>
  )
}
